const keyMap = {
  'sterling silver': 'sterling-silver',
  'gold vermeil': 'gold-vermeil',
  'oxidized sterling silver': 'oxidized-silver'
};

function updateCare(optionValue) {
  const key = optionValue.toLowerCase().trim();
  const id = keyMap[key];
  if (!id) return;
  document.querySelectorAll('#kefi-care-content > div').forEach(function(div) {
    div.style.display = 'none';
  });
  const target = document.getElementById('kefi-care-' + id);
  if (target) target.style.display = 'block';
}

document.addEventListener('change', function(e) {
  if (e.target.name && e.target.name.includes('option1')) {
    // Try label lookup first
    const label = document.querySelector('label[for="' + e.target.id + '"]');
    if (label) {
      updateCare(label.textContent);
      return;
    }
    // Fall back: find checked input's aria-label or data attributes
    const ariaLabel = e.target.getAttribute('aria-label');
    if (ariaLabel) {
      updateCare(ariaLabel);
      return;
    }
    // Last resort: parse option name from the input name attribute
    // name format: ...option1-{variantId}, check all variant labels in the DOM
    const allLabels = document.querySelectorAll('label[for*="option1"]');
    allLabels.forEach(function(l) {
      const input = document.getElementById(l.getAttribute('for'));
      if (input && input.checked) {
        updateCare(l.textContent);
      }
    });
  }
});
// Trigger on page load for the initially selected variant
window.addEventListener('DOMContentLoaded', function() {
  var checked = document.querySelector('label[for^="option1"]');
  if (checked) {
    var input = document.getElementById(checked.getAttribute('for'));
    if (input && input.checked) updateCare(checked.textContent);
  }
});
